// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import { toastError, toastSuccess } from '../../../utility/toastutill'
import { AddOpportunity, deleteOpportunityById, updateOpportunityById, getById, getAllOpportunities } from '../../../services/opportunities.service'


export const getOpportunity = createAsyncThunk('Opportunity/getOpportunity', async params => {

  let query = ''
  if (params) {
    if (params.sort) {
      query = `${query}&sort=${params.sort}`
    }
    if (params.sortColumn) {
      query = `${query}&sortColumn=${params.sortColumn}`
    }
    if (params.q) {
      query = `${query}&q=${params.q}`
    }
    if (params.perPage) {
      query = `${query}&perPage=${params.perPage}`
    }
    if (params.page) {
      query = `${query}&page=${params.page}`
    }
    if (params.status) {
      query = `${query}&status=${params.status}`
    }
  }
  const response = await getAllOpportunities(query)
  return {
    params,
    data: response.data.data,
    OpportunityCount: response.data.OpportunityCount
  }
})

export const getOpportunityById = createAsyncThunk('Opportunity/getOpportunityById', async id => {
  try {
    const response = await getById(id)
    toastSuccess(response.data.message)
    return response.data.data
  } catch (error) {
    toastError(error)
    return error
  }
})

export const addOpportunity = createAsyncThunk('Opportunity/addOpportunity', async (formData, { dispatch }) => {

  try {
    const res = await AddOpportunity(formData)
    if (res.data) {
      toastSuccess(res.data.message)
      await dispatch(getOpportunity())
    }

    return res.data.success ? res.data.success : false
  } catch (error) {
    toastError(error)
    return error
  }

})

export const updateOpportunity = createAsyncThunk('Opportunity/updateOpportunity', async (formData, { dispatch }) => {

  try {
    const res = await updateOpportunityById(formData.id, formData)
    if (res.data.success) {
      toastSuccess(res.data.message)
      await dispatch(getOpportunity())
    }

    return res.data.success ? res.data.success : false
  } catch (error) {
    toastError(error)
    return error
  }

})

export const deleteOpportunity = createAsyncThunk('Opportunity/deleteOpportunity', async (id, { dispatch }) => {
  try {
    const res = await deleteOpportunityById(id)
    if (res.data.success) {
      toastSuccess(res.data.message)
      await dispatch(getOpportunity())
    }
    return id
  } catch (error) {
    toastError(error)
    return error
  }
})

export const OpportunitySlice = createSlice({
  name: 'Opportunity',
  initialState: {
    data: [],
    params: {},
    allData: [],
    selectedOpportunity: null,
    success: false
  },
  reducers: {

  },
  extraReducers: builder => {
    builder
      .addCase(getOpportunity.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.OpportunityCount
      })
      .addCase(getOpportunityById.fulfilled, (state, action) => {
        state.selectedOpportunity = action.payload
      })
      .addCase(addOpportunity.fulfilled, (state, action) => {
        state.success = action.payload
      })
      .addCase(updateOpportunity.fulfilled, (state, action) => {
        state.selectedOpportunity = null
      })
  }
})

export default OpportunitySlice.reducer
